import { Component, EventEmitter, Output } from '@angular/core';
import { Toolbar } from 'ionic-angular';
import { ToolbarType } from '../../../services/lineup-service';

@Component({
  selector: 'toolbar-tshirt',
  templateUrl: 'toolbar-tshirt.html'
})
export class ToolbarTshirtComponent {
  @Output() onTypeSelected = new EventEmitter<ToolbarType>();
  @Output() onAddPlayer = new EventEmitter<ToolbarType>();

  onCloseClick() {
    this.onTypeSelected.emit(ToolbarType.main)
  }

  onAddPlayerClick() {
    this.onAddPlayer.emit();
  }
}





// WEBPACK FOOTER //
// /src/pages/apps/lineup/components/toolbar/toolbar-tshirt/toolbar-tshirt.ts